import { IListOfSectorAndLocations } from 'pages/Configurations/Users/Children/UnitySectorColum'
import { StatsCount } from 'types/global'
/**
 * Valores de atributos para entidades user do servicenow
 */
export interface IUserRegistryAttr {
    display_value: string
    link?: string
    value: string
}
/**
 * Interface para user da listagem principal via servicenow
 */
export interface ILocationWithSector {
    name: string
    sys_id: string
    sectors: { name: string; sys_id: string }[]
}
export interface IUserServiceNowV2 {
    u_user_email: string
    u_user_id: string
    name: string
    u_locations: ILocationWithSector[]
    u_location_sector: ILocationWithSector[]
    u_profile: string
    'u_notifica_users.u_profile'?: string
    u_sector: string
    u_user: string
    'u_user.email': string
    u_active: string
    sys_id: string
}
export interface IUserServiceNow {
    u_location: IUserRegistryAttr
    u_profile: IUserRegistryAttr
    u_sector: IUserRegistryAttr
    u_user: IUserRegistryAttr
    'u_user.email': IUserRegistryAttr
    u_active: IUserRegistryAttr
    sys_id: IUserRegistryAttr
}
/**
 * Interface para user de criação no servicenow, apenas nos serviço
 */
export interface IUserWithLocation {
    u_user?: string
    u_active?: string
    u_profile?: string
    u_locations?: {
        sys_id: string
        sectors: {
            sys_id: string
        }[]
    }[]
}
export interface IUser {
    u_user?: string
    u_profile?: string
    u_location?: string
    u_sector?: string
    u_location_sector?: string
    u_active?: string
    'u_user.email'?: string
    'u_notifica_users.u_profile'?: string
}
/**
 * Interface para redux action
 */
export interface IUserAction {
    type: string
    payload: any
}
/**
 * Interface para objeto reducer
 */
export type TypeTableColums = {
    link: string
    u_user: string
    u_profile: string
    listOfSectorAndLocations: IListOfSectorAndLocations[]
    u_location: string
    u_sector: string
    'u_user.email': string
    u_active: string
}

export interface IUserReducer {
    user?: IUserServiceNow
    userAllCount?: number
    userIndexTarget?: number
    usersList: UserServiceNowList
    usersListDataTable: TypeTableColums[]
    loading: boolean
    error: boolean
    userProfiles?: any[]
}

/**
 * Interface usada no Axios para retorno lista de usuário paginado
 */
export interface IResultUserGetAllPaginate {
    result: UserList
    stats: any
}
/**
 * Interface usada no Axios para retorno da contagem de usuários
 */
export interface IResultUserGetCount {
    result: UserStatsCount
}
/**
 * Interface usada no Axios para retorno de usuário por id
 */
export interface IResultUserGet {
    result: User[]
}

/**
 * Tipo para redux action
 */
export type UserAction = IUserAction
/**
 * Tipo para lista padrão
 */
export type UserList = IUser[]
/**
 * Tipo para lista padrão do entidade servicenow da listagem
 */
export type UserServiceNowList = IUserServiceNow[]
/**
 * Tipo para entidade servicenow
 */
export type UserServiceNow = IUserServiceNow
/**
 * Tipo para reducer
 */
export type UserReducer = IUserReducer
/**
 * Tipo para reducer
 */
export type User = IUser
/**
 * Tipo padrão para retorno de contagem
 */
export type UserStatsCount = StatsCount
/**
 * Objeto padrão com os valores possíveis para perfis de usuários
 */
export const userProfiles = [
    { id: 'admin', title: 'Administrador' },
    { id: 'nsp', title: 'NSP' },
    { id: 'location_qa', title: 'Qualidade da unidade' },
    { id: 'location_manager', title: 'Gestor da unidade' },
    { id: 'unit_general_manager', title: 'Diretor Geral Unidade' },
    { id: 'corporate_quality_management', title: 'Gestão Qualidade Corporativa' },
    { id: 'corporate_quality_board', title: 'Diretoria Qualidade Corporativa' }
]
/**
 * Objeto reducer padrão
 */
export const UserReducerTypeInitiator: IUserReducer = {
    user: null,
    usersList: [],
    usersListDataTable: [],
    loading: true,
    error: false,
    userAllCount: 0,
    userProfiles: userProfiles
}
/**
 * Objeto padrão
 */
export const UserTypeInitiator: IUser = {
    u_user: '',
    u_profile: '',
    u_location: '',
    u_sector: '',
    u_active: ''
}
/**
 * Tipo usado no Axios para retorno lista de usuários paginados
 */
export type ResultUserGetAllPaginate = IResultUserGetAllPaginate
/**
 * Tipo usado no Axios para retorno da contagem de setores
 */
export type ResultUserGetCount = IResultUserGetCount
/**
 * Tipo usado no Axios para retorno de setor por id
 */
export type ResultUserGetById = IResultUserGet
/*
 * Tipo usado no Axios para retorno de setor por id
 */
export type ResultUsersManagers = IResultUserGet
